import { APP_PERMISSIONS } from '@report/permission';
import { Button } from '@shared/components';
import { WithPermission } from '@shared/permissions';

interface PValuesAdjustmentButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

export default function PValuesAdjustmentButton(props: Readonly<PValuesAdjustmentButtonProps>) {
  const { disabled, onClick } = props;

  return (
    <WithPermission requiredPermission={[APP_PERMISSIONS.QBANK_ITEMS_ANALYSIS_REPORT.UPDATE]}>
      <Button disabled={disabled} onClick={onClick}>
        บันทึกรายการปรับปรุงค่า P
      </Button>
    </WithPermission>
  );
}
